import controller from './query.controller';
import template from './query.html';
import './query.scss';

export default {
	path:           '/query',
	template,
	controllerAs:   '$ctrl',
	controller,
	title:          'menu.query',
	reloadOnSearch: false,
};
